<template>
  <div id="profile-section">
    <div class="info-section">
      <p class="user-name" @click="toProfile">{{ activeUser.fullName }}</p>
      <p class="user-role" @click="toProfile">
        {{ $t(userRoles[activeUser.role]) }}
      </p>
      <p class="logout" @click="logout">
        {{ $t("profileSection.screen.logout.text") }}
      </p>
    </div>
    <div class="profile-img-section">
      <div class="profile-img" @click="toProfile">
        <profile-image :user="activeUser" :size="'50px'" :fontSize="'20px'" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ProfileSection",
  methods: {
    ...mapActions({
      removeUserInfo: "user/removeUserInfo"
    }),
    toProfile() {
      if (this.$route.path !== "/profile") {
        this.$router.push("/profile");
      }
    },
    logout() {
      this.$router.push("/login");
      this.removeUserInfo();
      // .then(() => this.$router.push("/login"));
    }
  },
  computed: {
    ...mapGetters({
      getActiveUser: "user/getActiveUser"
    }),
    activeUser() {
      return this.getActiveUser;
    },
    userRoles() {
      return this.$variables.roles;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#profile-section {
  height: 100%;
  display: flex;
  align-items: center;
  .info-section {
    text-align: right;
    .user-name {
      font-size: 14px;
      font-weight: bold;
      cursor: pointer;
    }
    .user-role {
      font-size: 11px;
      margin-bottom: 5px;
      cursor: pointer;
    }
    .logout {
      font-size: 10px;
      cursor: pointer;
      color: $color-danger;
      transition: all 0.3s ease-in-out;
    }
    .logout:hover {
      color: red;
      font-weight: bold;
    }
  }
  .profile-img-section {
    width: 65px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .profile-img {
      cursor: pointer;
    }
  }
}
</style>
